import { useHistory } from "react-router-dom";
import { TbArrowLeft } from "react-icons/tb";
import { PageAlertRenderer } from "../PageAlert";

export interface PageHeaderWithBackProps {
  title: string;
  subTitle?: string;
  backTo?: string;
  onBack?: () => void;
  className?: string;
}

export const PageHeaderWithBack = ({
  title,
  subTitle,
  backTo,
  onBack,
  className = "mb-6",
}: PageHeaderWithBackProps) => {
  const history = useHistory();

  const handleBack = () => {
    if (onBack) {
      onBack();
      return;
    }
    if (backTo) {
      history.push(backTo);
    }
  };

  return (
    <header className={`w-full ${className}`}>
      <PageAlertRenderer priority={10} />
      <div className="flex w-full items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-xl font-bold text-brand-dark dark:text-gray-100 md:text-2xl">{title}</h1>
        {subTitle && (
          <p className="mt-1 break-words text-xs text-gray-500 dark:text-gray-400 md:text-sm">{subTitle}</p>
        )}
      </div>
      {(backTo || onBack) && (
        <button
          type="button"
          onClick={handleBack}
          className="btn-back w-auto shrink-0"
        >
          <TbArrowLeft className="h-4 w-4" />
          Voltar
        </button>
      )}
      </div>
    </header>
  );
};
